export default "__VITE_ASSET__CCYSM4q9__"